/*
 * AAIKO quick shop.
 *
 * The drawn card (265:8509) puts a size strip over the bottom of the media.
 * A cursor opens it on hover, which is pure CSS; this file covers the two
 * paths CSS cannot do:
 *
 *   1. the bag glyph in Extras (242:8626) toggles the strip, which is how
 *      touch and keyboard reach it;
 *   2. a size adds that exact variant to the bag.
 *
 * Nothing about cart state is computed here. The POST goes to /cart/add.js
 * and the result is announced on `shopify:cart:lines-update` with
 * action 'add', which is the contract aaiko-cart-drawer.js documents: it
 * refreshes itself and opens.
 */
(function () {
  'use strict';

  /* Included by every surface that renders the card with a strip - the
     collection grid, the PDP, the favourites, the look grid - and, since
     03/09/2026, by the bag drawer on every page. A page can therefore carry
     this file twice, and the browser runs a repeated <script src> again: two
     click listeners would add every tapped size twice. Register once. */
  if (window.aaikoQuickshopReady) return;
  window.aaikoQuickshopReady = true;

  var CART_EVENT = 'shopify:cart:lines-update';

  function cartRoutes() {
    var fallback = { cart_add_url: '/cart/add.js', cart_url: '/cart' };
    try {
      /* snippets/scripts.liquid declares `const Theme` on the lexical scope,
         not on window, so this is a bare-identifier read behind a guard. */
      // eslint-disable-next-line no-undef
      return (typeof Theme !== 'undefined' && Theme.routes) || fallback;
    } catch (error) {
      return fallback;
    }
  }

  function card(el) {
    return el.closest('.aaiko-card');
  }

  function close(target) {
    if (!target) return;
    target.removeAttribute('data-quickshop-open');
    var toggle = target.querySelector('[data-aaiko-quickshop-toggle]');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  }

  function closeAll(except) {
    var open = document.querySelectorAll('.aaiko-card[data-quickshop-open]');
    for (var i = 0; i < open.length; i++) {
      if (open[i] !== except) close(open[i]);
    }
  }

  function onToggle(button) {
    var host = card(button);
    if (!host) return;
    var isOpen = host.hasAttribute('data-quickshop-open');
    closeAll(host);
    if (isOpen) {
      close(host);
      return;
    }
    host.setAttribute('data-quickshop-open', '');
    button.setAttribute('aria-expanded', 'true');
  }

  function add(button) {
    var id = button.getAttribute('data-variant-id');
    if (!id || button.getAttribute('aria-busy') === 'true') return;

    var routes = cartRoutes();
    var host = card(button);
    var resolve;
    var reject;
    var promise = new Promise(function (res, rej) {
      resolve = res;
      reject = rej;
    });

    /* Announced BEFORE the request settles, exactly as Horizon's own button
       does: the drawer waits on the promise and only then refreshes, so a
       slow network cannot leave it showing a stale bag. */
    var event = new CustomEvent(CART_EVENT, { bubbles: true, detail: { source: 'aaiko-quickshop' } });
    event.action = 'add';
    event.promise = promise;
    document.dispatchEvent(event);

    button.setAttribute('aria-busy', 'true');

    /* CLIENT FEEDBACK (02/09/2026): "werkt niet duidelijk, de maat gaat te
       langzaam de winkelmand in". The strip used to stay open until the add
       AND the follow-up cart read both settled - two sequential round trips
       with the shopper staring at an unchanged row. The tapped cell inverts
       via [aria-busy] the instant the tap lands (card CSS), holds for a beat
       so the answer is seen, and the strip closes on its own; the drawer
       still opens only when the promise resolves, so nothing claims success
       before the cart says so. On failure the strip is already closed - the
       promise rejection reaches the drawer exactly as before. */
    window.setTimeout(function () {
      close(host);
    }, 250);

    var body = new FormData();
    body.append('id', id);
    body.append('quantity', '1');

    fetch(routes.cart_add_url, { method: 'POST', headers: { Accept: 'application/json' }, body: body })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        if (data && data.status) throw new Error(data.description || data.message || 'add failed');
        return fetch(routes.cart_url + '.js').then(function (response) {
          return response.json();
        });
      })
      .then(function (cart) {
        resolve({ detail: { source: 'aaiko-quickshop', itemCount: cart.item_count, items: cart.items } });
      })
      .catch(function (error) {
        console.warn('[aaiko-quickshop] add failed', error);
        reject(error);
      })
      .then(function () {
        button.removeAttribute('aria-busy');
      });
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-aaiko-quickshop-toggle]');
    if (toggle) {
      event.preventDefault();
      onToggle(toggle);
      return;
    }

    var size = event.target.closest('[data-aaiko-quickshop-add]');
    if (size) {
      event.preventDefault();
      add(size);
      return;
    }

    /* A click anywhere else closes whatever the bag glyph opened. Hover-opened
       strips are CSS-only and close themselves. */
    if (!event.target.closest('.aaiko-card[data-quickshop-open]')) closeAll(null);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeAll(null);
  });
})();
